// Fixed minimum-education levels — kept in sync with backend EDUCATION_LEVELS
// in main.py (used for both the posting-form dropdown and the filter checklist).
export const EDUCATION_LEVELS = [
  "PG Diploma", "B.Tech / B.E.", "Any Graduate", "Graduation Not Required",
  "B.B.A. / B.M.S.", "B.Sc", "B.Com", "B.C.A.", "Diploma",
  "B.A - Bachelor of Arts", "LLB - Bachelor of Laws", "B.Pharma", "B.Ed",
  "BFA - Bachelor of Fine Arts", "Integrated PG", "Any Postgraduate",
  "MBA/PGDM", "M.Tech", "LLM", "MCA", "CA", "MS/M.Sc(Science)", "M.Com",
  "Medical-MS/MD", "Post Graduation Not Required",
];

export const FRESHNESS_OPTIONS = [
  { value: "1", label: "Last 1 day" },
  { value: "3", label: "Last 3 days" },
  { value: "5", label: "Last 5 days" },
  { value: "7", label: "Last 7 days" },
  { value: "15", label: "Last 15 days" },
  { value: "25", label: "Last 25 days" },
  { value: "30", label: "Last 30 days" },
];
